import script from "./ProblemUnderstanding.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemUnderstanding.vue?vue&type=script&setup=true&lang=js"

import "./ProblemUnderstanding.vue?vue&type=style&index=0&id=f0a4b79e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0a4b79e"]])

export default __exports__